import { ROUTES } from "modules/navigation/enums/RoutesEnum"

/**
 * Checks if given path exist in defined app routes
 */
export const isValidRoute = (path: string) => {
    return Object.values(ROUTES).includes(path as ROUTES);
}
